import { Event } from "../../models/events";
import {
  getEventOperationalStatus as resolveEventOperationalStatus,
  type EventOperationalStatus,
} from "../eventSchedule";

export type { EventOperationalStatus };

export const getEventOperationalStatus = (event: Event): EventOperationalStatus =>
  resolveEventOperationalStatus(event.active, event.startDate, String(event.duration ?? ""));

export const orderEventsPerDate = (
  data: Event[] | undefined,
  sortOrder: "asc" | "desc" = "asc"
): Event[] => {
  if (!data || !Array.isArray(data)) return [];
  const multiplier = sortOrder === "desc" ? -1 : 1;
  return [...data].sort(
    (a, b) =>
      multiplier *
      (new Date(a.startDate).getTime() - new Date(b.startDate).getTime())
  );
};
